import { Mixins, Component, VModel, Prop, Watch, Ref } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'
import { favoriteCountries, countries } from '@/_type/mobile'
import { AsYouType, CountryCode, parsePhoneNumber } from 'libphonenumber-js'

// Exception for Legevakten
// https://www.helsenorge.no/hjelpetilbud-i-kommunene/legevakt/
const LegevaktenNumber = '116117'
const NorwegianAmbulanceNumber = '113'
const NorwegianPoliceNumber = '112'
const NorwegianFireDepartmentNumber = '110'

@Component({
    inheritAttrs: false,
})
export default class PhoneInput extends Mixins<MixinInterface>() {
    @VModel() phoneNumber!: string | null
    @Prop({ default: true }) beValidation!: boolean
    @Ref('phone') phone!: HTMLInputElement

    get required() {
        return this.$attrs.hasOwnProperty('required') && this.$attrs.required
    }

    get outlined() {
        return this.$attrs.hasOwnProperty('outlined')
    }

    get solo() {
        return this.$attrs.hasOwnProperty('solo')
    }

    get disabled() {
        return this.$attrs.hasOwnProperty('disabled') && this.$attrs.disabled
    }

    get valid() {
        if (!this.phoneNumber) {
            return !this.required
        }

        let isValidPhoneNumber = false
        try {
            const result = parsePhoneNumber(this.phoneNumber)
            isValidPhoneNumber =
                result.isValid() ||
                (this.countrycode === 'NO' && result.nationalNumber === LegevaktenNumber) ||
                (this.countrycode === 'NO' && result.nationalNumber === NorwegianAmbulanceNumber) ||
                (this.countrycode === 'NO' && result.nationalNumber === NorwegianPoliceNumber) ||
                (this.countrycode === 'NO' &&
                    result.nationalNumber === NorwegianFireDepartmentNumber)
        } catch {
            // ignore parsing error (for example TOO_SHORT)
        }

        return isValidPhoneNumber
    }

    allCountries = { ...favoriteCountries, ...countries }

    number = ''

    @Watch('phoneNumber', { immediate: true })
    init() {
        if (this.phoneNumber) {
            if (!this.number || !this.phoneNumber.includes(this.number)) {
                this.number = this.formatPhoneNumber(this.phoneNumber)
            }
        } else {
            if (!!this.number) {
                this.number = ''
            }
        }
    }

    @Watch('number')
    handleNumber() {
        if (this.number?.includes('+')) {
            this.phoneNumber = this.number
        } else {
            this.phoneNumber = this.number ? `${this.code}${this.number}` : null
        }
    }

    get regexCode() {
        return `^(\\d{0,${this.code.length - 1}})`
    }

    get countrycode() {
        let countrycode = 'NO'
        if (this.phoneNumber?.includes('+')) {
            let countriesArray = Object.entries(this.allCountries)
            let res = countriesArray.find((item) => {
                return this.phoneNumber?.includes(item[1])
            })
            countrycode = res ? res[0] : 'NO'
        }
        return countrycode
    }

    set countrycode(countrycode) {
        let code = '+47'
        if (this.phoneNumber?.includes('+')) {
            let countriesArray = Object.entries(this.allCountries)

            let res = countriesArray.find((item) => {
                return this.phoneNumber?.includes(item[1])
            })

            code = res ? res[1] : '+47'

            this.phoneNumber = `${this.allCountries[countrycode]}${
                this.phoneNumber.split(`${code}`)[1]
            }`
            this.number = this.phoneNumber
        }
    }

    get code() {
        return this.allCountries[this.countrycode]
    }

    set code(code) {
        this.phoneNumber = code ? `${code}${this.number}` : null
    }

    applyMask(): void {
        this.number = new AsYouType(this.countrycode as CountryCode).input(this.number)
        this.$emit('keyup')
    }

    focus() {
        this.phone?.focus()
    }
}
